import React from 'react';
import './css/SideBarButton.css'

function SideBarButton(props){
    console.log(props)
    return(
        <button className="sidebarbutton" onClick={props.onClick}>{props.text}</button>
    )
}

export default SideBarButton;